import { render } from "./AreaLink.vue?vue&type=template&id=f25c2792"
import script from "./AreaLink.vue?vue&type=script&lang=js"
export * from "./AreaLink.vue?vue&type=script&lang=js"

import "./AreaLink.vue?vue&type=style&index=0&id=f25c2792&lang=css"

import exportComponent from "/dados/apps/pdcrm/app_atual/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__